<ion-app>
  <ng-progress id="headerProgressBar" [spinner]="false" color="#e94054"></ng-progress>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
